import React from "react";
import { VegaChip } from "@heartlandone/vega-react";

const ActivityCategory = ({ category }) => {
  return (
    category && (
      <VegaChip
        text={category}
        size="small"
        bgColor="bg-primary"
        textColor="text-primary"
        variant="outlined"
      ></VegaChip>
    )
  );
};

export default ActivityCategory;
